import styled from "styled-components";

export const StyledSupport = styled.div`
    .support{
        position: relative;
        overflow: hidden;

        .shadow{
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.4);
        }
        .support-video{
            position: absolute;
            min-height: 100%;
            min-width: 100%;
            z-index: -2;
        }

        .support-main{
            padding: 250px 0 450px;
            text-align: center;
            color: #FFFFFF;
            position: relative;
            h1{
                font-weight: 700;
                font-size: 96px;
                line-height: 131px;

            }

            p{
                font-size: 32px;
                line-height: 44px;
                margin-top: 30px;
            }
            @media (max-width:992px) {
                h1{
                    font-size: 60px;
                }
                p{
                    font-size: 20px;
                }
            }
            @media (max-width:576px) {
                padding: 300px 0;
                h1{
                    font-size: 40px;
                    line-height: 54px;
                }
                p{
                    margin-top: 15px;
                    font-size: 16px;
                    line-height: 22px;
                }
            }
        }
    }

    .tab-section{
        margin-top: 100px;

        .tab-main{
            display: flex;
            padding: 0 30px;

            .tab-item{
                width: 33.3%;
                padding: 30px 0;
                text-align: center;
                cursor: pointer;
                transition: all 0.2s ease-in-out;

                &.active{
                    background: #DADADA;
                }
                &:hover{
                    background: #DADADA50;
                }

                h3{
                    font-weight: 600;
                    font-size: 20px;
                    line-height: 27px;
                    margin-top: 25px;
                }
            }
            @media (max-width: 768px) {
                padding: 0;

                .tab-item{
                    h3{
                        font-size: 16px;
                    }
                }
            }
            @media (max-width: 576px) {
                .tab-item{
                    padding: 15px 0;
                    svg{
                        width: 24px;
                        height: 24px;
                    }
                    h3{
                        margin-top: 10px;
                        font-size: 10px;
                        line-height: 14px;
                    }
                }
            }
        }

        .tab-body{
            margin: 100px 0;
            @media (max-width: 576px) {
                margin-top: 40px;
            }
        }
    }
`